"use client";
import React from "react";
import { CommentType } from "../../../constants/mockPosts";
import { useState } from "react";
import Image from "next/image";
const Comment2 = ({ comment }: { comment: CommentType }) => {
  const [showReplies, setShowReplies] = useState(false);

  return (
    <div className=" border-themeColor text-secondary-main my-4">
      <div className="flex w-full items-start gap-5">
        <Image
          height={48}
          width={48}
          src={comment.photo}
          alt={comment.name}
          className="size-12 rounded-full"
        />
        <div className=" flex-1">
          <div className="first flex items-center w-full  justify-between">
            <div className="items flex items-center gap-6">
              <h5 className="font-semibold h6">{comment.name}</h5>
              <p className="text-sm text-label-main">
                {new Date(comment.date).toDateString()}
              </p>
            </div>

            <div className="replies text-themeColor">
              {comment.replies.length > 0 && (
                <span>
                  {comment.replies.length}{" "}
                  {comment.replies.length > 1 ? "replies" : "reply"}
                </span>
              )}
            </div>
          </div>

          <p className="mt-1">{comment.text}</p>

          {comment.replies.length > 0 && (
            <button
              onClick={() => setShowReplies(!showReplies)}
              className="text-themeColor text-sm mt-2"
            >
              <span className="flex gap-2 items-center">
                <span
                  className={`transform transition-all duration-500 ${
                    showReplies ? "rotate-180" : ""
                  }`}
                >
                  <Triangle />
                </span>
                {showReplies ? "Hide Replies" : `Show Replies`}
              </span>
            </button>
          )}

          {showReplies && (
            <div className="mt-2 ml-5 border-gray-200 pl-3">
              {comment.replies.map((reply) => (
                <Comment2 key={reply.id} comment={reply} />
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Comment2;

export const Triangle = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.49983 4.16682H17.4998C17.6517 4.1673 17.8006 4.20918 17.9304 4.28797C18.0602 4.36676 18.1661 4.47946 18.2367 4.61395C18.3072 4.74844 18.3397 4.89962 18.3307 5.05122C18.3218 5.20283 18.2716 5.34911 18.1857 5.47432L10.6857 16.3077C10.3748 16.7568 9.6265 16.7568 9.31483 16.3077L1.81483 5.47432C1.72801 5.34937 1.67711 5.20301 1.66763 5.05116C1.65816 4.8993 1.69048 4.74776 1.76109 4.61298C1.8317 4.47821 1.93789 4.36536 2.06813 4.2867C2.19837 4.20804 2.34768 4.16658 2.49983 4.16682Z"
        fill="var(--primary-color)"
      />
    </svg>
  );
};
